export const boxSlotSessionKeys = {
  all: ["boxSlotSession"] as const,
  scheduledSessionsInRange: (programId: string, startDate: Date, endDate: Date) =>
    [
      ...boxSlotSessionKeys.all,
      "scheduledSessionsInRange",
      programId,
      startDate.toISOString(),
      endDate.toISOString(),
    ] as const,
  scheduledSession: (programId: string, date: Date) =>
    [...boxSlotSessionKeys.all, "scheduledSession", programId, date.toISOString()] as const,
  session: (sessionId: string) => [...boxSlotSessionKeys.all, "session", sessionId] as const,
}
